export default __webpack_public_path__ + "static/media/img--living-dining-2.20c19ceb.jpg";